import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { PrintButton} from 'sos-common/js/components/PrintButton/PrintButton';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { makeTranslator, translateFunc } from '../../../utilities/translations';
import { Register } from 'sos-common/js/commonTypes/Registers.types';
import { ValidationResult, StepValidationMap } from 'sos-common/js/commonTypes/validation.types';
import { QualityRegisterOrderModel, QualityRegisterOrderStore } from '../../../models';
import {  saveFormOrder} from 'sos-eservice-common/js/Redux/Actions';
import {  areAllFieldsErrorFree} from '../../../utilities/helpers';
import SummaryStep from '../../../components/SummaryStep';
import SummaryStepFragment from '../../../components/SummaryStepFragment';
import SendButton from 'sos-common/js/components/FormControls/SendButton';
export interface Step3Props extends StepChildProps {
  Translate?: translateFunc;
  saveFormOrder: typeof saveFormOrder;
  formModel: QualityRegisterOrderModel;
  hasHitSummary: boolean;
  orderId: string;
  qualityRegistries: Register[];
  validationResults: ValidationResult[];
  stepValidationMap: StepValidationMap;
  isSending: boolean;
}
class Step3 extends React.Component<Step3Props, {}> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }
  getTitle = () => 'Granska och skicka in';

  componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle()
    });
  }

  getRegisterNameFromId = (id: number): string => {
    const registries = this.props.qualityRegistries;

    const item = registries.find(r => r.DhsId === id);
    if (item === null || item === undefined) {
      return this.props.Translate('/general/forms/uppSaknas');
    }
    return item.Name;
  };

  getFormValue = (formName: string, detailedFormName = null): string => {
    let value: string = _.get(this.props.formModel, formName);
    if (value === null || value === undefined || value === '' || value.length === 0) {
      value = this.props.Translate('/general/forms/uppSaknas');
      if (detailedFormName !== null) {
        value = detailedFormName + ' saknas';
      }
    }
    value = String(value); // don't delete this line :p
    switch (value) {
      case 'false':
        value = 'Nej';
        break;
      case 'true':
        value = 'Ja';
        break;
    }
    return value;
  };

  registriesSummary = () => {
    const { formModel, Translate } = this.props;
    const noData = Translate('/general/forms/uppSaknas');
    const regs = this.getRegisterNameFromId(_.get(formModel, 'QualityRegister', 0));
    const otherRegs = this.getFormValue('OtherQualityRegister');

    if (regs === noData && otherRegs === noData) return noData;
    if (regs === noData && otherRegs !== noData) return otherRegs;
    if (regs !== noData && otherRegs === noData) return regs;
    if (regs !== noData && otherRegs !== noData) return regs;
  };

  validateFields = (...fieldNames: string[]): boolean => {
    const { validationResults } = this.props;
    return areAllFieldsErrorFree(validationResults, ...fieldNames);
  };

  onClickSave = (e: React.MouseEvent) => {
    e.preventDefault();
    this.props.saveFormOrder();
  };

  render() {
    const { Translate, formModel, orderId, validationResults, navProps } = this.props;
    const noOrderId = !orderId;
    const sendDisabled = validationResults && validationResults.length > 0 ? true : false;
    return (
      <div id="step3" tabIndex={-1}>
        <h2>{Translate('/general/forms/summering')}</h2>
        <PrintButton />
        <div className="form-summary">
          <SummaryStep
            stepId={0}
            goToStep={navProps.goToStep}
            isDone={_.get(this.props.stepValidationMap, '[0].isValid', false)}
            headerTitle="Kvalitetsregister"
            headerBackString={Translate('/general/navigering/gaTillSteg1')}
          >
            <SummaryStepFragment isValid={this.validateFields('QualityRegister')}>
              <div>
                <strong>{Translate('/qualityFormPage/vilketreg')}</strong>
                <br />
                {this.registriesSummary()}
              </div>
            </SummaryStepFragment>
          </SummaryStep>

          <SummaryStep
            stepId={1}
            goToStep={navProps.goToStep}
            isDone={_.get(this.props.stepValidationMap, '[1].isValid', false)}
            headerTitle="Beställare"
            headerBackString={Translate('/general/navigering/gaTillSteg2')}
          >
            <SummaryStepFragment isValid={this.validateFields(...['ContactPerson.Name', 'ContactPerson.Email'])}>
              <div>
                <strong>{Translate('/qualityFormPage/contactPerson')}</strong>
                <br />
                {this.getFormValue('ContactPerson.Name', Translate('/general/contact/namn'))}
                <br />
                {this.getFormValue('ContactPerson.Email', Translate('/general/contact/epost'))}
              </div>
            </SummaryStepFragment>

            <SummaryStepFragment isValid={this.validateFields('Organisation')}>
              <div>
                <strong>{Translate('/qualityFormPage/cpuaTitleShort')}</strong>
                <br />
                {this.getFormValue('Organisation')}
              </div>
            </SummaryStepFragment>
          </SummaryStep>
        </div>
        <div className="form-submit">
          <SendButton onClickSave={this.onClickSave} isSending={this.props.isSending} sendDisabled={sendDisabled} />
        </div>
      </div>
    );
  }
}

const mapState2Props = (state: QualityRegisterOrderStore) => {
  return {
    Translate: makeTranslator(state.globals.translations),
    formModel: state.formModel,
    orderId: state.globals.orderId,
    hasHitSummary: state.globals.hasHitSummary,
    qualityRegistries: state.registers.qualityRegistries,
    validationResults: state.validationState.validationResults,
    stepValidationMap: state.validationState.stepValidationMap,
    isSending: state.globals.isSending
  } as Partial<Step3Props>;
};

const mapDispatch2Props = dispatch => {
  return {
    saveFormOrder: bindActionCreators(saveFormOrder, dispatch)
  };
};

const StepThree = connect(
  mapState2Props,
  mapDispatch2Props
)(Step3);
export { StepThree };
